// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ISO = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ISO = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ISO = _exports.ISO = function ISO(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.927 8.49609V16.9268C16.927 17.4779 16.7081 18.0065 16.3184 18.3961C15.9287 18.7858 15.4002 19.0048 14.8491 19.0048H5.15214C4.60104 19.0048 4.07251 18.7858 3.68283 18.3961C3.29314 18.0065 3.07422 17.4779 3.07422 16.9268V3.07402C3.07422 2.52292 3.29314 1.99439 3.68283 1.6047C4.07251 1.21502 4.60104 0.996094 5.15214 0.996094H9.42703C9.79431 0.996149 10.1465 1.14205 10.4063 1.40172L16.5214 7.51687C16.7811 7.7766 16.927 8.12882 16.927 8.49609Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1.3418V6.5366C10 6.904 10.1459 7.25635 10.4057 7.51614C10.6655 7.77593 11.0179 7.92188 11.3853 7.92188H16.5801",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.87891 12.0497H6V15.6861H6.87891V12.0497Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.39622 13.1399H10.2378C10.2307 12.4599 9.68919 12 8.84402 12C8.01305 12 7.41468 12.4528 7.42001 13.1293C7.41824 13.6815 7.80531 13.9922 8.43386 14.136L8.81383 14.2248C9.21333 14.3171 9.39267 14.4254 9.39622 14.6296C9.39267 14.8516 9.18493 15.006 8.83159 15.006C8.44274 15.006 8.18706 14.8249 8.16752 14.4751H7.32591C7.33656 15.3256 7.92782 15.7322 8.84224 15.7322C9.74778 15.7322 10.284 15.3221 10.2876 14.6314C10.284 14.0508 9.8916 13.6957 9.17427 13.5376L8.86177 13.4666C8.53152 13.3956 8.322 13.2855 8.3291 13.0689C8.33088 12.87 8.50133 12.7262 8.84224 12.7262C9.18493 12.7262 9.37314 12.8807 9.39622 13.1399Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.1636 13.8679C14.1636 12.6658 13.4037 12 12.4271 12C11.447 12 10.6924 12.6658 10.6924 13.8679C10.6924 15.0646 11.447 15.7358 12.4271 15.7358C13.4037 15.7358 14.1636 15.07 14.1636 13.8679ZM13.2652 13.8679C13.2652 14.5799 12.9527 14.9652 12.4271 14.9652C11.9033 14.9652 11.589 14.5799 11.589 13.8679C11.589 13.1559 11.9033 12.7706 12.4271 12.7706C12.9527 12.7706 13.2652 13.1559 13.2652 13.8679Z",
      fill: "currentColor"
    }));
  };
});
